export const ALL_TIME_TO = new Date('2014-08-18T23:59:59');
export const DEFAULT_TIME = new Date('2014-08-18T00:00:00')

export const PIN_LENGTH = { MIN: 6, MAX: 6 };
export const CECO_LENGTH = { MIN: 4, MAX: 256 };
export const CECO_CODE_NAME = "cecoCode";

/**
 * Validates that a PIN is not weak.
 * Rejects fully sequential values, ascending or descending (e.g. 123456 / 654321),
 * values containing a run of 3 or more identical digits (e.g. 000111 / 111111),
 * and values built from a repeating block (e.g. 121212 / 123123).
 * @param {string|number} value - The PIN to validate.
 * @returns {boolean} true if the PIN is strong enough, false if weak.
 */
export const isStrongPin = (value) => {
    const pin = String(value);
    if (!/^\d+$/.test(pin)) return false;

    // Reject 3 or more identical consecutive digits (e.g. 000111, 111111).
    if (/(\d)\1{2,}/.test(pin)) return false;

    // Reject any adjacent repeated 2-3 digit block (e.g. 1212 -> 121213, 123123, 121212).
    if (/(\d{2,3})\1/.test(pin)) return false;

    // Reject any run of SEQUENCE_THRESHOLD or more consecutive digits,
    // ascending or descending (e.g. 123456, 654321, 123455 -> 12345).
    const SEQUENCE_THRESHOLD = 3;
    let ascRun = 1;
    let descRun = 1;
    for (let i = 1; i < pin.length; i++) {
        const diff = pin.charCodeAt(i) - pin.charCodeAt(i - 1);
        ascRun = diff === 1 ? ascRun + 1 : 1;
        descRun = diff === -1 ? descRun + 1 : 1;
        if (ascRun >= SEQUENCE_THRESHOLD || descRun >= SEQUENCE_THRESHOLD) return false;
    }

    return true;
};

export const USER_DATA = {
    id: '',
    userTypeId: '',
    name: '',
    lastName: '',
    secondLastName: '',
    genderId: '',
    phoneNumber: '',
    statusId: '',
    email: '',
    password: '',
    pin: '',
    documentId: '',
    dob: null,
    isValid: function (){
        return this.name !== '' &&
            this.lastName !== '' &&
            (!this.id || (this.id && this.email !== '' &&
            this.email != null))
    }
}


export const CONTRACTOR_EMPLOYEE_DATA = {
    ...USER_DATA,
    contractorEmployeeStatusId: '',
    contractorId: null,
    deviceId: null,
    firebaseId: null,
    selfie: null,
    userId: null,
    toCreateUpdate: function (password) {
        return {
            contractorEmployeeStatusId: this.contractorEmployeeStatusId !== '' ? this.contractorEmployeeStatusId : null,
            contractorId: sessionStorage.getItem('contractorId'),
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            selfie: this.selfie,
            userId: this.userId,
            documentId: this.documentId,
            password: password || null
        };
    },
    isValidEmployee: function (){
        return  this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId;
    }
}

export const TABS_SUPPLIER_EMPLOYEE = {
    DETAILS: {
        INDEX: 0
    },
    PHOTO: {
        INDEX: 1
    },
    SUMMARY: {
        INDEX: 2
    }
}

export const SUPPLIER_EMPLOYEE_DATA = {
    ...USER_DATA,
    supplierEmployeeStatusId: null,
    selfie: null,
    supplierId: null,
    userId: null,
    toRegister: function (password) {
        return {
            supplierEmployeeStatusId: this.supplierEmployeeStatusId !== '' ? this.supplierEmployeeStatusId : null,
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            supplierId: this.supplierId !== null ? null : sessionStorage.getItem('providerId'),
            userId: this.userId,
            documentId: this.documentId,
            password: password || null
        };
    },
    isValidEmployee: function (){
        return  this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId;
    }
}

export const EMPLOYEE_DATA = {
    departmentId: '',
    employeeId: '',
    startDate: null,
    endDate: null,
    roleId: '',
    zoneId: '',
    contractStatusId: '',
    id: '',
    [CECO_CODE_NAME]: null,
    isValid: function (isPilgrimsValidation = false) {

        const validation =
            this.employeeId !== '' &&
            this.startDate !== null &&
            this.roleId !== '';

        if (isPilgrimsValidation) {
            return validation && (this.departmentId !== '' && this.departmentId !== null);
        }

        return validation;
    }
}

export const EXTRA_DATA = {
    field1: '',
    field2: '',
    field3: '',
    field4: '',
    field5: '',
    field6: '',
    field7: '',
    field8: '',
    field9: '',
    field10: '',
    field11: '',
    field12: '',
    field13: '',
    field14: '',
    field15: '',
}

export const HEADER_DATA = {
    header1: '',
    header2: '',
    header3: '',
    header4: '',
    header5: '',
    header6: '',
    header7: '',
    header8: '',
    header9: '',
    header10: '',
    header11: '',
    header12: '',
    header13: '',
    header14: '',
    header15: '',
}


export const DIGITAL_PERSON_DEVICE_MODEL = {
    UNKNOWN: 0,
    OPTICAL: 1,
    CAPACITIVE: 2,
    THERMAL: 3,
    PRESSURE: 4,
}

export const CUSTOMIZED_MODEL = {
    fromValue: null,
    toValue: null,
    allDays: false,
    allTime: false,
    checkedZones: [],
    dayArray: [],
    isValid: function () {
        if (!this.checkedZones || this.checkedZones.length === 0) return false;
        if (!this.dayArray || this.dayArray.length === 0) return false;
        return !(this.fromValue === null || this.toValue === null);
    },
    clear: function (){
        return {
            ...this,
            checkedZones: [],
            dayArray: [],
            allTime: false,
            allDays: false,
            fromValue: DEFAULT_TIME,
            toValue: DEFAULT_TIME
        };
    }
};

export const SERVICE ={
    PILGRIMS:3
}
